import { formatEuro } from '../lib/catalog'

// Prices are normal weight and muted on the parchment ground — the kiosk's treatment.
// Tabular numerals so the right-aligned columns line up digit for digit.
export function Price({ cents, size }: { cents: number; size: number }) {
  return (
    <span
      className="font-secondary font-normal text-gray-600 tabular-nums whitespace-nowrap"
      style={{ fontSize: size, lineHeight: 1 }}
    >
      {formatEuro(cents)}
    </span>
  )
}

/** Statiegeld is charged on top of the price and is never folded into it. */
export function Deposit({ cents, size = 22, inline = true }: { cents: number; size?: number; inline?: boolean }) {
  if (!cents) return null
  return (
    <span
      className={'font-secondary font-normal text-gray-400' + (inline ? ' ml-[10px]' : '')}
      style={{ fontSize: size, lineHeight: 1 }}
    >
      {'+ ' + formatEuro(cents) + ' deposit'}
    </span>
  )
}
